import asyncActionTypes from '../actions/types.js';

const initialState = {
};

const electronicVisa = ( state = initialState, action ) => {
  switch (action.type) {
    case asyncActionTypes.ELECTRONIC_VISA.START:
      return {
        ...state,
      };
    case asyncActionTypes.ELECTRONIC_VISA.SUCCESS:

      const electronicVisa = action.payload;
      
      return {
        ...state,
        electronicVisa,
      };
    case asyncActionTypes.ELECTRONIC_VISA.FAIL:
      return {
        ...state,
        error : action.error,
      };
    default:
      return state;
  }
};

export default electronicVisa;